import React, { useCallback, useEffect } from 'react';
import { Icon, Button } from '@pwc/pwc-deals-ui';
import classNames from 'classnames';

import LayoutTab from './LayoutTab/LayoutTab';
import { useClickedOutsideOfRef } from '../../hooks/useClickedOutsideOfRef';
import CONSTANTS from '../../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/Constants';

import './RightPanel.scss';

export const testId = 'right-panel';

const RightPanel = ({
  className = '',
  handleCollapse,
  handleLayoutTypeChange,
  activeLayoutId,
  layouts,
  isPoTopicLayout = false,
  setShowLostCommentsModal,
  selectedLayoutIdRef,
}) => {
  const poTopicLayoutTypeTitleDescriptionMap =
    CONSTANTS.PO_TOPIC_LAYOUT_TYPE_TO_LAYOUT_TITLE_DESCRIPTION_MAP;
  const layoutTypeTitleDescriptionMap =
    CONSTANTS.LAYOUT_TYPE_TO_LAYOUT_TITLE_DESCRIPTION_MAP;
  const ref = useClickedOutsideOfRef(
    (clickOutside) => clickOutside && handleCollapse()
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') {
        handleCollapse();
      }
    },
    [handleCollapse]
  );

  useEffect(() => {
    window.addEventListener(CONSTANTS.USER_EVENTS.KEY_DOWN, handleKeyDown);

    return () => {
      window.removeEventListener(CONSTANTS.USER_EVENTS.KEY_DOWN, handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div ref={ref} className={classNames('right-panel2', className)}>
      <div className="right-panel2__header">
        <Button className="button-no-underline" onClick={handleCollapse}>
          <Icon name="close" width="20" className="icon fill icon-orange" />
        </Button>
      </div>
      <LayoutTab
        handleLayoutTypeChange={handleLayoutTypeChange}
        activeLayoutId={activeLayoutId}
        layouts={layouts}
        layoutTypesTitleDescriptionMap={
          isPoTopicLayout
            ? poTopicLayoutTypeTitleDescriptionMap
            : layoutTypeTitleDescriptionMap
        }
        setShowLostCommentsModal={setShowLostCommentsModal}
        selectedLayoutIdRef={selectedLayoutIdRef}
      />
    </div>
  );
};

export {
  LAYOUTS_BY_TYPE,
  TOPIC_LAYOUTS,
  KFA_LAYOUTS,
} from './LayoutTab/Layouts';
export default RightPanel;
